"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;
// Reusable utility functions

function createReducer(initialState, handlers) {
  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    var rootState = arguments[2];

    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action, rootState);
    }

    return state;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/createReducer.js
// module id = 45
// module chunks = 0